export default __webpack_public_path__ + "static/profile-pic-c213318dee196e2192aeb75ad28dc202.jpg";